module.exports = __webpack_public_path__ + "img/sana.2c95e1e2.png";